import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { Icon } from "@/lib/ui";

const NAV = [
  { to: "/app", icon: "House", label: "Home", end: true },
  { to: "/app/activity", icon: "Bell", label: "Activity" },
  { to: "/app/profile", icon: "User", label: "Profile" },
];

export default function UserShell() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-secondary/40 pb-24">
      <div className="max-w-md mx-auto bg-background min-h-screen relative">
        <Outlet />
      </div>
      <nav className="fixed bottom-0 inset-x-0 z-40 border-t border-border bg-white/90 backdrop-blur-xl">
        <div className="max-w-md mx-auto grid grid-cols-4">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex flex-col items-center gap-1 py-3 text-xs font-semibold transition-colors ${isActive ? "text-primary" : "text-muted-foreground"}`
              }
            >
              <Icon name={n.icon} className="w-5 h-5" />
              {n.label}
            </NavLink>
          ))}
          <button
            data-testid="nav-claim"
            onClick={() => nav("/claim")}
            className="flex flex-col items-center gap-1 py-3 text-xs font-semibold text-muted-foreground tap"
          >
            <Icon name="Plus" className="w-5 h-5" />
            Add tag
          </button>
        </div>
      </nav>
    </div>
  );
}
